<template>
  <!-- 应用根组件，仅包含路由视图 -->
  <router-view />
</template>

<script setup lang="ts">
// 根组件无需额外逻辑，作为路由出口
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--el-font-family);
  background-color: #f5f7fa;
}
</style>
    